import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Floating "Go to top" button.
 * Appears after the user scrolls past `showAfter` pixels; otherwise fully
 * unmounted so it doesn't sit in the DOM. Includes a small opacity + slide
 * animation on mount for polish.
 */
export const GoToTop = ({ showAfter = 400 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > showAfter);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [showAfter]);

  if (!visible) return null;

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type='button'
      onClick={scrollTop}
      aria-label='Scroll to top'
      data-testid='go-to-top-button'
      className='fixed bottom-6 right-6 z-40 h-11 w-11 rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/25 border border-primary/20 hover:scale-105 active:scale-95 transition-transform duration-150 ease-out flex items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 animate-in fade-in slide-in-from-bottom-2 duration-200'
    >
      <ArrowUp className='h-5 w-5' />
    </button>
  );
};

export default GoToTop;
